import { ReactNode, RefObject } from 'react'
import {
	TextField,
	Label,
	TextArea as AriaTextArea,
	TextAreaProps,
	TextFieldProps,
} from 'react-aria-components'

type Props = TextFieldProps & {
	innerRef?: RefObject<HTMLTextAreaElement>
	label?: ReactNode
	textareaProps?: TextAreaProps
}

export function Textarea({ innerRef, label, className = '', textareaProps, ...props }: Props) {
	return (
		<TextField className={`flex flex-col gap-1 ${className ?? ''}`} {...props}>
			{label && (
				<Label className="flex gap-1 font-normal leading-tight text-xs">{label}</Label>
			)}
			<AriaTextArea
				ref={innerRef}
				className="w-full bg-transparent text-sm text-gray-700 font-sans font-normal outline outline-0 disabled:border-gray-100 border border-gray-400 p-2 rounded focus:border-gray-900"
				rows={8}
				{...textareaProps}
			/>
		</TextField>
	)
}
